import {
	post,get
} from "../util/crmAxios";
import {getBasicUrls} from "../util/config"
export const selectCustomInviteList = (params) => post('/crm/invite/selectCustomInviteList', params) //试听列表
export const canleCustomInvite = (params) => post('crm/invite/canleCustomInvite', params);//取消
export const updateCustomInviteSignInfo = (params) => post('/crm/invite/updateCustomInviteSignInfo', params);//确认
export const getGwPasswordStrByAccountId = (params) => get('/crm/customer/getGwPasswordStrByAccountId',params );//获取官网明文密码by accountId

// 学员查询-es
export const queryMultiCampusCustomerInfo = (params) => post('/crm/search/queryMultiCampusCustomerInfo', params)
// 学员详情活动记录
export const queryStudentActivityList = (params) => get('/erp/studentdetail/queryStudentActivityList', params)

// 学员详情活动记录
export const checkCustomRegisterAndMachineAccount = (params) => post('/base/learning/checkCustomRegisterAndMachineAccount', params)
// 学员详情活动记录
export const queryStudentLearnMachineAuditio = (params) => post('/erp/studentAudition/queryStudentLearnMachineAuditio', params)
// 页面埋点
export const insertTrackingData = (params) => post(getBasicUrls().schoolm+'manage/potential/insertTrackingData', params);

// 入门账号管理分页查询接口
export const queryBeginnerAccountInfo = (params) => post(getBasicUrls().schoolm+'manage/beginner/queryBeginnerAccountInfo', params);

// 尝鲜版分页查询接口
export const queryTrialAccountInfo = (params) => post(getBasicUrls().schoolm+'manage/trial/queryTrialAccountInfo', params);

// 查询经销商入门账号额度
export const getAgentRemainUseNum = (params) => post(getBasicUrls().schoolm+'manage/beginner/getAgentRemainUseNum', params);

// 查询经销商潜在客户下拉
export const queryCustomInfo = (params) => post(getBasicUrls().schoolm+'manage/beginner/queryCustomInfo', params);

// 查询学习机下拉
export const queryMachineInfo = (params) => post(getBasicUrls().schoolm+'manage/beginner/queryMachineInfo', params);

// 查询通行证信息
export const grantTempPassInfo = (params) => post(getBasicUrls().schoolm+'manage/beginner/grantTempPassInfo', params);

// 申请通行证
export const applyTempPass = (params) => post(getBasicUrls().schoolm+'manage/beginner/applyTempPass', params);

// 入门账号开通
export const openBeginnerAccountInfo = (params) => post(getBasicUrls().schoolm+'manage/beginner/openBeginnerAccountInfo', params);
// 查询人脸接口
export const queryAccountUserFace = (params) => post(getBasicUrls().schoolm+'manage/beginner/queryAccountUserFace', params);

// 尝鲜版查询人脸接口
export const queryTrialAccountUserFace = (params) => post(getBasicUrls().schoolm+'manage/trial/queryAccountUserFace', params);